import { Table, Button, FormGroup, Label, Col, Input } from 'reactstrap';
import React, { useState, useEffect } from 'react'
import DocumentModal from './DocumentModal';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from "react-router-dom";
import { BiRefresh } from 'react-icons/bi';
import axios from 'axios';
import BootstrapTable from 'react-bootstrap-table-next';
import MinimizableContainer from './MinimizableContainer';
import ResearchKeyDropdown from './ResearchKeyDropdown';
import { showToastAction } from '../../../redux/toastSlice';


const DocumentsValidated1 = () => {
    const dispatch = useDispatch()
    const [DocData, setDocData] = useState([])
    const [selectedDoc, setSelectedDoc] = useState([])
    const selectedProject = useSelector(state => state.selectedProject);
    const reloadDocuments = useSelector(state => state.reloadDocuments);
    // const { form_name } = useParams();
    // const { isLoading, data: documents, refetch } = useQuery("getDocumentsValidated" + selectedProject.name + form_name, () => getDocumentsValidated(selectedProject.name, form_name))

    const [minimized, setMinimized] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [selectedDocument, setSelectedDocument] = useState(null);
    const preferences = useSelector(state => state.preferences);
    const preferencesArray = Object.entries(preferences)
    const filteredPreferences = preferencesArray.filter((el) => el[1] === true);

    const history = useHistory()

    useEffect(() => {
        axios.get(`/project/${selectedProject?.name}/${window.location.pathname.split("/")[2]}/Documents/validated`).then(res => {
            setDocData(res?.data?.data)
        })

    }, [])

    const validate = async (ids) => {
        // console.log(id);
        try {
            if (selectedDoc.length !== 0) {
                await axios.post(`/project/${selectedProject?.name}/${window.location.pathname.split("/")[2]}/document/recycle`, { "selected_ids": ids }).then(res => {
                    // console.log('res...........edrfgedgf.........', res);
                    history.push(`/form/${window.location.pathname.split("/")[2]}/documents`)
                })
            } else dispatch(showToastAction({ message: 'Please select any documents', showToast: true }))
        }
        catch (err) {
            dispatch(showToastAction({ message: err.response?.data?.errorMessage ?? "Error", showToast: true }))
        }
    }

    const documentsColumns = [
        ...filteredPreferences.map((([key]) => {
            return {
                dataField: key,
                text: key,
                formatter: (data) => formatterColumn(data)
            }
        })),
    ];

    const selectRow = {
        mode: 'checkbox',
        clickToSelect: true,
        selected: selectedDoc,
        onSelect: (row, select) => handleOnSelect(row, select),
        onSelectAll: (select, rows) => handleOnSelectAll(select, rows),
        style: { backgroundColor: '#75dfff40' }
    };

    const handleOnSelect = (row, isSelect) => {
        if (isSelect) setSelectedDoc([...selectedDoc, row._id])
        else setSelectedDoc(selectedDoc.filter(x => x !== row._id))
    }

    const handleOnSelectAll = (isSelect, rows) => {
        const ids = rows.map(r => r._id);
        if (isSelect) setSelectedDoc(ids)
        else setSelectedDoc([])
    }

    const formatterColumn = (data) => {
        return data ? <SmartText text={data} /> : '-'
    }

    const SmartText = ({ text, length = 20 }) => {
        const [showLess, setShowLess] = React.useState(true);

        if (text.length < length) {
            return <div>{text}</div>;
        }

        return (
            <div>
                {showLess ? text.slice(0, length) : text}
                {showLess ? <a className="read-or-hide" onMouseOver={() => setShowLess(!showLess)}
                >....</a> : <a className="read-or-hide" onMouseOver={() => setShowLess(true)}
                >...less</a>}
            </div>
        );
    };

    const handleClose = () => setShowModal(false);

    return (
        <>
            {/* <MinimizableContainer className="form-documents marginTop30" Title={Title} minimized={minimized} onMinimizeClick={() => setMinimized(!minimized)} > */}
            <DocumentModal />
            {/* <h3>Document Validation</h3><br /> */}
            <MinimizableContainer
                // OptionsButton={() => ResearchKeyDropdown({ "documentsStatus": "VALIDATED" })}
                className="form-documents marginTop30"
                Title={Title}
                minimized={minimized}
                onMinimizeClick={() => setMinimized(!minimized)}
            // showPrefrence={() => toggleModel(!showPreferences)}
            >
                <DocumentModal
                    selectedDocument={selectedDocument}
                    show={showModal}
                    handleClose={handleClose}
                    ModalType={''}
                    document_status={'VALIDATED'}
                />
                {/* <Preferences
                    // minimized={isdashPrefMinimized}
                    // setMinimized={setIsDashPrefMinimized}
                    // togglePreference={togglePreference}
                    isActive={showPreferences}
                    handleClose={() => toggleModel(!showPreferences)}
                /> */}
                {/* <div className="relative new-table-resposive"> */}
                <div className="relative table_box">
                    {/* <Table>
                        <thead className="sticky top-0 left-0 bg-white border-0">
                            <tr>
                                {filteredPreferences.map(([pref]) => <th>{pref.toUpperCase()}</th>)}
                                <th className="text-right" style={{ paddingRight: "30px" }}>ACTIONS</th>
                            </tr>
                        </thead>
                        <tbody>
                            {documents?.data?.data.map((val) => {
                                const values = Object.entries(val);
                                const filteredValues = values.filter((val) => preferences[val[0]]);
                                return <tr>
                                    {filteredPreferences.map(([pref]) => <td className="wrapword">{val[pref] ? <SmartText text={val[pref]} /> : ''}</td>)}
                                    <td className="d-flex" style={{ justifyContent: "flex-end" }}>
                                        {val.recycle ? <button className="edit-btn" title="recycle" onClick={() => validate(val?._id, val)}><BiRefresh fontSize={30} /></button> : ''}
                                        <button onClick={() => handleShow(val)} className="edit-btn" title="edit"><i className="ti-pencil-alt"></i></button>
                                        <button className="remove-btn" title="delete" onClick={() => handleDeleteDocument(val._id)}><i className="ti-trash"></i></button>
                                    </td>
                                </tr>
                            })}
                        </tbody>
                    </Table> */}
                    {DocData.length !== 0 &&
                        <BootstrapTable
                            keyField='_id'
                            data={DocData}
                            columns={documentsColumns}
                            hover
                            selectRow={selectRow}
                            headerClasses="header-class  header-model"
                            noDataIndication={'No data found'}
                        />
                    }
                </div>
            </MinimizableContainer>
            {/* <div className="max-h-96 relative new-table-resposive"> */}
            {/* <div className="relative table_box"> */}
            {/* {DocData.length !== 0 &&
                    <BootstrapTable
                        keyField='_id'
                        data={DocData}
                        columns={documentsColumns}
                        hover
                        selectRow={selectRow}
                        headerClasses="header-class  header-model"
                        noDataIndication={'No data found'}
                    />
                } */}
            {/* <Table>
                    <thead className="sticky top-0 left-0 bg-white border-0">
                        <tr>
                            {filteredPreferences.map(([pref]) => <th>{pref.toUpperCase()}</th>)}
                            <th className="text-center">ACTIONS</th>
                        </tr>
                    </thead>
                    <tbody>
                        {DocData?.map(v => {
                            return (
                                <tr>
                                    {filteredPreferences.map(([pref]) => <td>{v[pref] ? <SmartText text={v[pref]} /> : ''}</td>)}
                                    <td className="text-center" onClick={() => validate(v?._id)}>
                                        <button className="edit-btn" title="recycle" ><BiRefresh fontSize={30} /></button>
                                    </td>
                                </tr>
                            )
                        })}


                    </tbody>
                </Table> */}
            {/* </div> */}
            <div className="recycle-btn" style={{ marginTop: "30px", float: "right", gap: "10px", display: 'flex' }}>
                <label className='btn btn-secondary' htmlFor="dropdown-box-input" data-toggle="dropdown-box-outer" onClick={() => history.push(`/recycledocs2/${window.location.pathname.split("/")[2]}`)}>Cancel</label>
                <label className='btn btn-secondary btn-recycle' htmlFor="dropdown-box-input" data-toggle="dropdown-box-outer" onClick={() => validate(selectedDoc)}>Recycle</label></div>
            {/* </MinimizableContainer> */}
            {/* onClick={()=> history.push("/recycledocs5")} */}
        </>
    )
}

function Title() {
    return <h3 style={{ marginBottom: 0, marginLeft: 18 }} className="heading">DOCUMENT VALIDATION</h3>
}

export default DocumentsValidated1
